export default "__VITE_ASSET__416bfb33__"